import React, { useMemo } from "react"
import { useLocation } from "react-router-dom"
import styled, { css } from "styled-components"

import { Paragraph } from "components/text"
import { FontConfigurations } from "theme"
import { StepProps } from "./"
import { TEST_MARKER_CONSTANTS } from "shared/test-selectors"

const MobileLabel = styled.div``
const DesktopLabel = styled.div`
  display: none;
`

const StepItem = styled(Paragraph).attrs({
  ...FontConfigurations.eyebrowSm
})<{ isActive: boolean }>`
  text-align: center;
  padding: ${props => props.theme.space[1]} 0;
  border-width: 3px 0;
  border-style: solid;
  border-color: transparent;

  @media screen and (min-width: ${props => props.theme.breakpoints.md}px) {
    ${DesktopLabel} {
      display: block;
    }

    ${MobileLabel} {
      display: none;
    }
  }

  /* StepLinks BEFORE the active one. */
  color: ${props => props.theme.colors.evergreen};

  ${props =>
    props.isActive &&
    css`
      /* THE active StepLink */
      color: ${props.theme.colors.lightTeal};
      border-bottom-color: ${props.theme.colors.lightTeal};

      /* StepLinks AFTER the active one */
      & ~ & {
        color: ${props.theme.colors.silverDark};
        border-color: transparent;
      }
    `}
`

const Step: React.FC<StepProps> = ({ label, labelMobile, paths }) => {
  const location = useLocation()
  const isActive = useMemo(() => !!paths.find(path => location.pathname.includes(path)), [paths, location])

  return (
    <StepItem forwardedAs="div" isActive={isActive} data-test={`${TEST_MARKER_CONSTANTS.STEP_NAV_ITEM}-${label}`}>
      {labelMobile ? (
        <>
          <MobileLabel>{labelMobile}</MobileLabel>
          <DesktopLabel>{label}</DesktopLabel>
        </>
      ) : (
        label
      )}
    </StepItem>
  )
}

export default Step
